import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ChakraProvider } from '@chakra-ui/react';
import { ProductProvider } from './contexts/product-ctx';
import { MenuProvider } from './contexts/menu-with-quantities-ctx';
import { theme } from './themes/theme';
import { AppSettingsProvider } from './contexts/app-settings-ctx';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <BrowserRouter>
    <ChakraProvider theme={theme}>
    <AppSettingsProvider>
      <MenuProvider>
        <ProductProvider>
          <App />
        </ProductProvider>
      </MenuProvider>
      </AppSettingsProvider>
    </ChakraProvider>
  </BrowserRouter>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
